import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { apiGet } from '../lib/apiClient';

const FeatureFlagContext = createContext({ flags: {}, loading: true, refresh: () => {} });

export const FeatureFlagProvider = ({ children, token }) => {
  const [flags, setFlags] = useState({});
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!token) { setLoading(false); return; }
    try {
      const data = await apiGet('/api/features');
      setFlags(data?.features || {});
    } catch (e) {
      console.error('Failed to load feature flags:', e);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <FeatureFlagContext.Provider value={{ flags, loading, refresh }}>
      {children}
    </FeatureFlagContext.Provider>
  );
};

export const useFeatureFlags = () => useContext(FeatureFlagContext);

export const useFeatureFlag = (flagId) => {
  const { flags, loading } = useFeatureFlags();
  return { enabled: flags[flagId] !== false, loading };
};

export const FeatureGate = ({ flag, children, fallback = null }) => {
  const { enabled, loading } = useFeatureFlag(flag);
  if (loading) return null;
  return enabled ? children : fallback;
};
